import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import { clientMachine } from './client.machine';
import type { ClientEvent } from './events';

export const useClientRef = () => feature('client');
export const useClient = <R>(selector: (snapshot: SnapshotFrom<typeof clientMachine>) => R): R =>
  useFeature('client', selector);
export const useClientActions = () => {
  const ref = useClientRef();
  return {
    loadViewClients: () => ref.send({ type: 'client.load-viewClients' }),
    openDialog: () => ref.send({ type: 'client.open-dialog' }),
    open: (input: Extract<ClientEvent, { type: 'client.open' }>['input']) => ref.send({ type: 'client.open', input }),
  };
};
